var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialog.visible,
            "append-to-body": "",
            "modal-append-to-body": false,
            "close-on-click-modal": true,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
            closed: _vm.closed,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    disabled: _vm.dialog.disabled,
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "150px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "插件名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        attrs: { clearable: "", placeholder: "请输入插件名称" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "渠道选择：", prop: "channelId" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.channelId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "channelId", $$v)
                            },
                            expression: "form.channelId",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("全部渠道"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("指定渠道"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.channelId === "1"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            on: {
                              focus: function ($event) {
                                return _vm.handleClick()
                              },
                            },
                            model: {
                              value: _vm.form.appidFilterNames,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appidFilterNames", $$v)
                              },
                              expression: "form.appidFilterNames",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "key：", prop: "code" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        attrs: { placeholder: "请输入key" },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.dialog.disabled,
                  expression: "!dialog.disabled",
                },
              ],
              staticStyle: {},
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.hide } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirm },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("channel-popups", {
        attrs: {
          isAppendToBody: true,
          modelIsAppendToBody: false,
          "app-id": _vm.form.appidFilterList,
          visible: _vm.showPopups,
          multiple: false,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showPopups = $event
          },
          comfirm: _vm.handleConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }